import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  sendingEmail: false,
  emailSent: false,
  latestEmailSent: '',
});

export const { Creators, Types } = createActions({
  sendEmailQuoteRequested: ['email'],
  sendEmailQuoteSuccess: ['emailAddress'],
  sendEmailQuoteError: ['error'],
  sendEmailRetirementRequested: ['email'],
  sendEmailRetirementSuccess: ['emailAddress'],
  sendEmailRetirementError: ['error'],
  sendCallEmailRequested: ['phone'],
  sendCallEmailSuccess: ['result'],
  sendCallEmailError: ['error'],
});

export const Selectors = {
  // Selector will be here...
};

export const Reducer = createReducer(INITIAL_STATE, {
  [Types.SEND_EMAIL_QUOTE_REQUESTED]: state => state.merge({ sendingEmail: true }),
  [Types.SEND_EMAIL_QUOTE_SUCCESS]: (state, { emailAddress }) => state.merge({ sendingEmail: false, emailSent: true, latestEmailSent: emailAddress.data }),
  [Types.SEND_EMAIL_QUOTE_ERROR]: state => state.merge({ sendingEmail: false, emailSent: false }),
  [Types.SEND_EMAIL_RETIREMENT_REQUESTED]: state => state.merge({ sendingEmail: true }),
  [Types.SEND_EMAIL_RETIREMENT_SUCCESS]: (state, { emailAddress }) => state.merge({ sendingEmail: false, emailSent: true, latestEmailSent: emailAddress.data }),
  [Types.SEND_EMAIL_RETIREMENT_ERROR]: state => state.merge({ sendingEmail: false, emailSent: false }),
  [Types.SEND_CALL_EMAIL_REQUESTED]: state => state.merge({ sendingEmail: true }),
  [Types.SEND_CALL_EMAIL_SUCCESS]: (state) => {console.log('suc'); return state.merge({ sendingEmail: false, emailSent: true })},
  [Types.SEND_CALL_EMAIL_ERROR]: state => state.merge({ sendingEmail: false, emailSent: false }),
});
